import { useState, useEffect } from 'react';
import { ZIPCODE_NOT_FOUND_ERROR_CODE } from '../constants/error-codes';
import { pushErrorEvent } from '../utils/analytics';
import { capitalizeCityState } from '../utils/zip-code';
import { formatCityState } from '../components/shared/city-state-select/city-state-select';
import { addressesApi } from '../api/common/addresses';
import { ZIPCODE_REGEX } from '../constants/regex';
export const useZipCode = (zipcode, defaultCityState) => {
    const normalizeCityState = capitalizeCityState(defaultCityState || '');
    const defaultCities = normalizeCityState
        ? [
            {
                city: normalizeCityState.split(',')[0].trim(),
                state: normalizeCityState.split(',')[1].trim(),
            },
        ]
        : null;
    const [isInitialZipCode, setIsInitialZipCode] = useState(!!zipcode);
    const [isZipCodePending, setZipCodePending] = useState(false);
    const [cities, setCities] = useState(defaultCities);
    const [cityState, setCityState] = useState(normalizeCityState);
    const [zipCodeApiError, setZipCodeApiError] = useState(false);
    const [zipCodeNotFoundError, setZipCodeNotFoundError] = useState(false);
    useEffect(() => {
        loadCities(zipcode || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const resetCities = () => {
        setCities(null);
        setCityState('');
    };
    const loadCities = (zipCode) => {
        setZipCodeApiError(false);
        setZipCodeNotFoundError(false);
        const isValidZipCode = zipCode.match(ZIPCODE_REGEX);
        if (!isValidZipCode) {
            return;
        }
        setZipCodePending(true);
        addressesApi
            .getPostalList(zipCode)
            .then((data) => {
            setCities(data);
            const currentCityState = data.find(({ city, state }) => normalizeCityState === formatCityState(city, state));
            if (!currentCityState) {
                setCityState(formatCityState(data[0].city, data[0].state));
            }
        })
            .catch((error) => {
            var _a, _b, _c;
            pushErrorEvent('address card: edit address', 'inline', error || 'n/a', 'Please provide a valid zip code.');
            if (!isInitialZipCode) {
                if (((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors[0]) === null || _c === void 0 ? void 0 : _c.errorCode) ===
                    ZIPCODE_NOT_FOUND_ERROR_CODE) {
                    setZipCodeNotFoundError(true);
                    resetCities();
                    return;
                }
                setZipCodeApiError(true);
                resetCities();
            }
        })
            .finally(() => {
            setIsInitialZipCode(false);
            setZipCodePending(false);
        });
    };
    return {
        isZipCodePending,
        zipCodeApiError,
        zipCodeNotFoundError,
        cities,
        cityState,
        loadCities,
    };
};
